import { render, staticRenderFns } from "./TaxResidency.vue?vue&type=template&id=25b93925"
import script from "./TaxResidency.vue?vue&type=script&lang=js"
export * from "./TaxResidency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports